import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Icon, USER_INTERFACE_TICK_DONE } from '@bwoty-web/styleguide';
import { getCloudinaryUrl } from '../../../utils/imageUtils';
import './carouselItem.scss';

const CarouselItem = ({
  selected,
  onSelect,
  id,
  displayName,
  image,
  fullSize,
  siteSettings,
}) => {
  return ( 
    <div
      onClick={(e) => { onSelect(id, e.target) }}
      onKeyDown={(e) => {
        if (e.keycode === 13) {
          onSelect(id, e.target);
        }
      }}
      role='button'
      tabIndex="0"
      id={id}
      data-test={`${id.toLowerCase()}-button${selected ? '-selected':''}`}
      className={
        `carousel-item
        ${selected ? 'carousel--selected' : ''}
        ${fullSize ? 'carousel-item--full-size' : ''}
        `
      } 
    >

      { selected &&
        <div className='carousel-item__selected'>
          <Icon
            fill='#fff'
            className='vf-selected-option'
            path={USER_INTERFACE_TICK_DONE}
            size="xs"
          />
        </div>
      } 

      <img
        src={getCloudinaryUrl(siteSettings.imageUrl, image.image.mediaUrl, 275, 275)}
        className='carousel-item__image'
        alt='img' />
      <p className='carousel-item__label'>{displayName}</p>
    </div>
  )
}

CarouselItem.propTypes = {
  id: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  selected: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired,
  fullSize: PropTypes.bool.isRequired,
  siteSettings: PropTypes.shape({
    imageUrl: PropTypes.string.isRequired,
  }).isRequired,
}

const mapStateToProps = (state) => {
  return {
    attributeCollection: state.attributeCollection,
    siteSettings: state.siteSettings,
  };
};

export default connect(mapStateToProps)(CarouselItem);